import React, {useRef} from "react";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import TextField from "material-ui/TextField";
import {PropTypes} from "prop-types";
import DeleteOrderDialog from "../container/DeleteOrderDialog";
import {connectWithLifecycle} from "react-lifecycle-component";
import {push} from "react-router-redux";
import {
  addOrderLine,
  editOrderLine,
  deleteOrderLine,
  saveOrder,
  editOrder,
  cancelOrder,
  openDeleteOrderDialog
} from "../../redux/modules/ordersDuck";
import {
  selectTeamName,
  selectCustomerName
} from "../../redux/modules/ordersDuck";
// import { fetchTeamsRequest } from '../../redux/modules/teamsDuck'
// import { fetchProductsRequest } from '../../redux/modules/productsDuck'
import {ItemComponent} from "../presentational/Item";
import {
  getTeamIdMap,
  getTeamsMap,
  getOrdersMap,
  getCurrentOrderMap,
  getProductsMap,
  getTeamNameById
} from "../../redux/selectors";
import RaisedButton from "material-ui/RaisedButton";
import ActionAndroid from "material-ui/svg-icons/action/android";
import {List} from "material-ui/List";
import OrderLineListItem from "../presentational/OrderLineListItem";
import {TicketComponent} from "../presentational/Ticket";
import IconButton from "material-ui/IconButton";
import Delete from "material-ui/svg-icons/action/delete";
import ReactToPrint from "react-to-print";
import OnlineBanner from "../OnlineBanner";

const mapStateToProps = state => {
  const currentOrder = getCurrentOrderMap(state);
  const isNew = currentOrder
    ? getOrdersMap(state).find(o => o.get("id") === currentOrder.get("id")) ===
    undefined
    : false;
  return {
    teams: getTeamsMap(state),
    teamId: getTeamIdMap(state),
    teamById: getTeamNameById(state),
    currentOrder,
    products: getProductsMap(state),
    isLoading: state.isLoading,
    isNew
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleProductClick: product => () => {
    console.log("product", product);
    dispatch(addOrderLine(product));
    //dispatch(push('/variations'));
  },
  handleOrderLineEdit: lineId => {
    console.log("lineId", lineId);
    dispatch(editOrderLine(lineId));
    //dispatch(push('/variations'));
  },
  handleOrderLineDelete: lineId => {
    dispatch(deleteOrderLine(lineId));
  },
  handleOpenDialog: order => {
    dispatch(openDeleteOrderDialog(order));
  },
  handleTeamChange: (event, index, value) =>
    dispatch(selectTeamName(event.target.innerText, value)),
  handleNameChange: value => dispatch(selectCustomerName(value)),
  componentDidMount: props => {
    dispatch(editOrder(ownProps.match.params.id));
  },
  handleSaveOrder: order => {
    console.log("handleSaveOrder", order);
    dispatch(saveOrder(order));
    dispatch(push("/"));
  },
  handleCancelEdition: order => {
    dispatch(cancelOrder());
    dispatch(push("/"));
  }
});

const validate = order => {
  return !(
    order.get("customerName").length > 0 && order.get("orderLines").count() > 0
  );
};

const Order = props => {
  const {
    currentOrder,
    teamById,
    handleTeamChange,
    handleNameChange,
    products,
    teams,
    handleProductClick,
    handleOrderLineEdit,
    handleOrderLineDelete,
    handleSaveOrder,
    handleOpenDialog,
    handleCancelEdition,
    isLoading,
    isNew
  } = props;
  const componentRef = useRef();
  if (!currentOrder || isLoading) return <div>Loading</div>;
  const orderLines = currentOrder.get("orderLines");
  const calculateLabel = text =>
    currentOrder.get("customerName")
      ? currentOrder.get("orderLines").count() > 0 ? text : "¿Y los items?"
      : "¿Y el cliente?";

  const deleteOrderDialog = currentOrder
    ? <DeleteOrderDialog order={currentOrder.toJS()}/>
    : null;

  const orderStatus = order => {
    if (order.orderLines.length < 1) return "TODO";
    const finishedOrderLines = order.orderLines
      .map(ol => (ol.status === "DONE" ? 1 : 0))
      .reduce((a, b) => a + b, 0);
    if (finishedOrderLines === order.orderLines.length) return "DONE";
    if (order.orderLines.filter(ol => ol.status !== "TODO").length > 0)
      return "DOING";
    return "TODO";
  };

  const currentStatus = orderStatus(currentOrder.toJS());

  const paid = currentOrder.get("paid");
  const delivered = currentOrder.get("delivered");
  const orderList = orderLines
    ? orderLines.toJS().map((orderLine, index) => {
      const rightIcon = delivered
        ? ""
        : <IconButton
          onClick={() =>
            handleOrderLineDelete(orderLine.id)}
        >
          <Delete/>
        </IconButton>;

      return (
        <OrderLineListItem
          key={index}
          client={"client"}
          orderId={orderLine.orderId}
          orderLine={orderLine}
          onClick={() => handleOrderLineEdit(orderLine.id)}
          showPrice={true}
          rightIcon={rightIcon}
        />
      );
    })
    : <div/>;

  const backgroundColor = delivered
    ? "mediumpurple"
    : paid
      ? currentStatus === "DOING"
        ? "orange"
        : currentStatus === "DONE" ? "lightgreen" : "lightgrey"
      : "red";

  if (!teams) {
    return <div>Loading...</div>;
  } else
    return (
      <div>
        <TextField
          floatingLabelText="Nombre del cliente"
          errorText={
            !currentOrder.get("customerName")
              ? "Es imprescindible cubrir este campo"
              : undefined
          }
          value={currentOrder.get("customerName")}
          disabled={currentOrder.get("delivered")}
          onChange={(e, value) => handleNameChange(value)}
        />
        <br/>
        <SelectField
          floatingLabelText="Equipo"
          value={currentOrder.getIn(["team", "id"])}
          disabled={currentOrder.get("delivered")}
          onChange={(event, index, value) =>
            handleTeamChange(event, index, value)}
        >
          <MenuItem value={null} key="" primaryText=""/>
          {teams.map(team =>
            <MenuItem
              value={team.get("id")}
              key={team.get("id")}
              primaryText={team.get("name")}
            />
          )}
        </SelectField>
        <br/>
        {currentOrder.get("delivered")
          ? ""
          : <div>
            <h2>Selecciona un producto:</h2>
            <div style={{display: "flex", flexWrap: "wrap"}}>
              {products.map(product =>
                <ItemComponent
                  key={product.get("id")}
                  image={product.get("image")}
                  text={product.get("name")}
                  handleProductClick={handleProductClick(product)}
                />
              )}
            </div>
          </div>}
        <h2>Lista de items:</h2>
        <List>
          {orderList}
        </List>
        <h3>
          Total del pedido:{" "}
          {orderLines
            .map(line => line.get("unitPrice") * line.get("quantity"))
            .reduce((a, b) => a + b, 0)}€
        </h3>
        <br/>
        <div style={{backgroundColor: backgroundColor}}>
          {paid ? "Cobrado, " : "Pendiente de cobro, "}
          {currentStatus === "DONE"
            ? "producido "
            : currentStatus === "DOING"
              ? "en producción "
              : "pendiente de producir "}
          y
          {delivered ? " entregado" : " pendiente de entregar"}
        </div>


        <OnlineBanner >
        {!delivered
          ? <RaisedButton
            onClick={e => {
              return handleSaveOrder(currentOrder.set("paid", true));
            }}
            label={calculateLabel("Cobrado")}
            primary={true}
            disabled={validate(currentOrder)}
            style={{margin: 12}}
            icon={<ActionAndroid/>}
          />
          : ""}
        {!delivered
          ? <RaisedButton
            onClick={e => {
              return handleSaveOrder(currentOrder.set("paid", false));
            }}
            label={calculateLabel("Sin Cobrar")}
            secondary={true}
            disabled={validate(currentOrder)}
            style={{margin: 12}}
            icon={<ActionAndroid/>}
          />
          : ""}
        {!delivered && currentStatus === "DONE"
          ? <RaisedButton
            onClick={e => {
              return handleSaveOrder(currentOrder.set("delivered", true));
            }}
            label="Entregar"
            primary={true}
            style={{margin: 12}}
            icon={<ActionAndroid/>}
          />
          : ""}
        {delivered
          ? <RaisedButton
            onClick={e => {
              return handleSaveOrder(currentOrder.set("delivered", false));
            }}
            label="Recoger devolución"
            primary={true}
            style={{margin: 12}}
            icon={<ActionAndroid/>}
          />
          : ""}
        <RaisedButton
          onClick={e => {
            return handleCancelEdition();
          }}
          label="Cancelar"
          secondary={true}
          style={{margin: 12}}
          icon={<ActionAndroid/>}
        />
        {!isNew && !delivered
          ? <RaisedButton
            onClick={e => {
              return handleOpenDialog(currentOrder);
            }}
            label="Borrar"
            secondary={true}
            style={{margin: 12}}
            icon={<ActionAndroid/>}
          />
          : ""}
        {/*<RaisedButton*/}
        {/*onClick={e => {*/}
        {/*return handlePrintTicket(currentOrder);*/}
        {/*}}*/}
        {/*label="Ticket"*/}
        {/*secondary={true}*/}
        {/*style={{ margin: 12 }}*/}
        {/*icon={<ActionAndroid />}*/}
        {/*/>*/}
        <ReactToPrint
          copyStyles={true}
          bodyClass='ticket-to-print'
          pageStyle=''
          trigger={() => <RaisedButton
            label="Ticket"
            secondary={true}
            style={{margin: 12}}
            icon={<ActionAndroid/>}
          />}
          content={() => componentRef.current}
        />

        <TicketComponent order={currentOrder} getTeamById={teamById} ref={componentRef}/>
        </OnlineBanner>
        {/*<ReactToPrint*/}
        {/*trigger={() => <a href="#">Print this out!</a>}*/}
        {/*content={() => this.componentRef}*/}
        {/*/>*/}
        <br/>
        {deleteOrderDialog}
      </div>
    );
};

Order.propTypes = {
  currentOrder: PropTypes.object,
  products: PropTypes.object.isRequired,
  teams: PropTypes.object,
  handleProductClick: PropTypes.func.isRequired,
  handleOrderLineEdit: PropTypes.func.isRequired,
  handleOrderLineDelete: PropTypes.func.isRequired,
  handleTeamChange: PropTypes.func.isRequired,
  handleNameChange: PropTypes.func.isRequired,
  handleSaveOrder: PropTypes.func.isRequired
};

const OrderPage = connectWithLifecycle(mapStateToProps, mapDispatchToProps)(
  Order
);

export default OrderPage;

// const Teams = gql`
// query Teams{
//   teams {
//     id
//     name
//   }
// }
// `
// const OrderPageWithGraphQl = compose(
//   graphql(Teams),
//   graphql(apiMethods.saveOrderMutationGQL, {name: 'saveOrderMutation'})
// )(OrderPage)
// // const OrderPageWithGraphQl = graphql(apiMethods.saveOrderMutation, {name: 'saveOrderMutation'})(OrderPage);
// export default OrderPageWithGraphQl



// WEBPACK FOOTER //
// ./src/components/pages/Selling-Order.js